import { useState } from "react";
import { Modal } from "./Modal";

export function ConfirmDialog({
  title,
  body,
  confirmLabel = "Tasdiqlash",
  cancelLabel = "Bekor",
  danger = false,
  onCancel,
  onConfirm,
}: {
  title: string;
  body: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function go() {
    setBusy(true); setErr(null);
    try { await onConfirm(); }
    catch (e) { setErr((e as Error).message); setBusy(false); }
  }

  return (
    <Modal onClose={onCancel} labelledBy="confirm-title">
      <div className="modal-head"><h2 id="confirm-title">{title}</h2></div>
      <div className="modal-body">
        {err && <div className="error">{err}</div>}
        <div style={{ fontSize: "var(--text-base)", color: "var(--text)" }}>{body}</div>
      </div>
      <div className="actions">
        <button className="btn ghost" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
        <button
          className={`btn ${danger ? "danger" : ""}`}
          onClick={go}
          disabled={busy}
        >
          {busy ? "..." : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
